// Copyright limyifan1 <limyifan1@gmail.com> 2020. All Rights Reserved.
// Node module: hawkercentral
// This file is licensed under the MIT License.
// License text available at https://opensource.org/licenses/MIT

import Home from "./Home";
import Menu from "./Menu";
import Create from "./Create";
import Listing from "./Listing";
import Item from "./Item";
import Results from "./Results";
import Info from "./Info";
import About from "./About";
import Popup from "./Popup";
import SearchAll from "./SearchAll";
import ListForm from "./ListForm";
import ItemRendered from "./ItemRendered";
import Driver from "./Driver";
import Delivery from "./Delivery";
import Orders from "./Orders";
import Deliveries from "./Deliveries";
import Search from "./Search";
import Page from "./Page";
import PageAbout from "./PageAbout";
import PageItem from "./PageItem";
import PageCart from "./PageCart";
import PageCartChannel from "./PageCartChannel";
import PageDashboard from "./PageDashboard";
import PageConfirm from "./PageConfirm";
import Custom from "./Custom";
import PrivacyPolicy from "./PrivacyPolicy";

import { db, storage } from "./Firestore";

export default {
  Home,
  Menu,
  Create,
  Listing,
  Item,
  Results,
  Info,
  About,
  Popup,
  SearchAll,
  ListForm,
  ItemRendered,
  Driver,
  Delivery,
  Orders,
  Deliveries,
  Search,
  Page,
  PageAbout,
  PageItem,
  PageCart,
  PageCartChannel,
  PageConfirm,
  Custom,
  PageDashboard,
  PrivacyPolicy,
  db,
  storage,
};
